import styles from '@/components/help/pc/inquiry/Inquiry.module.scss';
import InquiryNoticeBox from '@/components/help/common/InquiryNoticeBox';

const InquiryNotice = () => {
  return (
    <InquiryNoticeBox
      title='문의 전 확인해보세요!'
      list={[
        {
          text: '접수 된 내용은 최초 접수 건부터 순차적으로 답변 드리고 있으며, 문의량이 급증하거나 확인이 필요한 문의인 경우 답변이 지연될 수 있으니 양해 부탁드립니다.',
        },
        {
          text: '이메일을 통한 통화시간 예약 문의 등 전화 상담 요청은 불가하오니 양해 부탁 드립니다.',
        },
      ]}>
      <div className={styles.SubSection}>
        <strong className={styles.SubTitle}>불량유저 신고 안내사항</strong>
        <ul className={styles.ListArea}>
          <li>증거 자료가 첨부되어야 접수가 가능합니다.</li>
          <li>
            운영정책의 위반 정도에 따라 경고부터 이용정지까지 처리될 수 있으며,
            음란물 및 운영정책 위반 정도가 심할 경우 경고없이 바로 이용 정지가
            될 수 있습니다.
          </li>
          <li>
            타인을 비방하거나 고의적인 허위 신고의 경우 신고자 또한 제재를 받을
            수 있습니다.
          </li>
        </ul>
      </div>
    </InquiryNoticeBox>
  );
};

export default InquiryNotice;
